// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__fZ2AG","label":"LabeledBox_label__1h2vn"};